import _ from "lodash";

export const isInvalidFileData = (data) => {
  const listField = [
    "No. (#)",
    "Model No.",
    "Status",
    "Pallet No.",
    "Carton No.",
    "Serial No.",
    "ETH MAC",
    "Wi-Fi MAC",
    "Bluetooth MAC",
    "Manufacture date",
    "Factory/line",
    "Chipset ID",
    "Storage (flash)",
    "Memory (RAM)",
    "RCU S/N",
    "FW Ver",
    "HW Ver",
  ];
  return Object.keys(data).some((field) => listField.includes(field));
};

export const convertExcelData = (data) => {
  const listDevice = data.map((device) => ({
    no: device["No. (#)"],
    modelNo: device["Model No."],
    status: device["Status"],
    palletNo: device["Pallet No."],
    cartonNo: device["Carton No."],
    serialNo: device["Serial No."],
    ethMac: formatMac(device["ETH MAC"].toString()),
    wifiMac: formatMac(device["Wi-Fi MAC"].toString()),
    bluetoothMac: formatMac(device["Bluetooth MAC"].toString()),
    mac: formatMac(device["ETH MAC"].toString()),
    manufactureDate: device["Manufacture date"],
    factoryLine: device["Factory/line"],
    chipSetId: device["Chipset ID"],
    storage: device["Storage (flash)"],
    memory: device["Memory (RAM)"],
    rcuSn: device["RCU S/N"],
    fwVersion: device["FW Ver"],
    hwVersion: device["HW Ver"],
  }));

  return _.unionBy(listDevice, (device) => device.ethMac);
};

export const formatMac = (ethMac) => {
  return ethMac.replaceAll(":", "");
};

// handle File
export const fileType = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
